<template>
  <div id="presenter" class="screen">
    <div class="section" style="text-align: center;">
      <p>Use 'slideLocations'</p>
      <v-btn v-on:click="uploadSlides" class="button">
        Upload
      </v-btn>
    </div>
  </div>
</template>

<script>
import presentationApi from '../api/presentationApi';

export default {
  name: 'Upload',
  methods: {
    uploadSlides() {
      if (window.slideLocations) {
        const updateSlidesProperty = window.slideLocations.map((slide) => {
          const bla = {};
          bla.image = slide;
          return bla;
        });

        presentationApi.updatePresentation(
          this.$route.params.presentationId,
          {
            slides: updateSlidesProperty
          }
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Upload.vue